import React from 'react';

import styles from './icon.module.css';


export default function ({icon, className, ...props}) {
    return React.createElement(icon, {className: `${styles.image} ${className}`, ...props});
}
